import $ from 'jquery';

"use strict";

var ViewAccountAddresses = Backbone.View.extend({

  initialize: function () {
    var customerAddresses = window.customerAddresses.map(function (address) {
      // return { [address.id]: address }
      
      var obj = {}
      obj[address.id] = address
      return obj
    })
    this.customerAddresses = customerAddresses.length ? Object.assign.apply(null, customerAddresses) : {};

    this.initProvinceSelects();
  },

  events: {
    // modal events
    'click [data-toggle="modal"]': function (e) {
      var $target = $(e.currentTarget)

      this.triggerModalClose();

      var targetModal = $target.data('modal');

      if (targetModal === 'address-modal') {
        this.populateAddressForm($target.data('address-id'));
      } else {
        this.populateDeleteAddressConfirm($target.data('address-id'));
      }

      var $targetModal = $('#' + targetModal)
      $targetModal.removeClass('hide');
      $('body').addClass('modal-active');

      var $modalContent = $targetModal.find('.modal');
      $modalContent.addClass('active');
      $modalContent.trigger('modal:open');
    },
    'click .modal .icon-close': function () { this.triggerModalClose() },
    'click .modal-overlay': function (e) {
      if ($(e.target).hasClass('modal-overlay')) this.triggerModalClose();
    },

    // province select events
    'input select#AddressCountry': function () { this.insertCurrentProvinceOptions() },
    'modal:open .modal': function () { this.insertCurrentProvinceOptions() },

    // phone number masker
    'input input#AddressPhone': function (e) {
      var value = e.target.value

      if (/^(\d){4}$/.test(value) || /^(\d){3}-(\d){4}/.test(value)) {
        $(e.target).val(value.replace(/\d$/, '-$&'));
      } else if (
        /^\d$/.test(value) ||
        /^(\d){2}$/.test(value) ||
        /^(\d){3}$/.test(value) ||
        /^(\d){3}-$/.test(value) ||
        /^(\d){3}-\d$/.test(value) ||
        /^(\d){3}-(\d){2}$/.test(value) ||
        /^(\d){3}-(\d){3}$/.test(value) ||
        /^(\d\d\d-){2}$/.test(value) ||
        /^(\d\d\d-){2}\d$/.test(value) ||
        /^(\d\d\d-){2}(\d){2}$/.test(value) ||
        /^(\d\d\d-){2}(\d){3}$/.test(value) ||
        /^(\d\d\d-){2}(\d){4}$/.test(value)
      ) {
        return;
      } else {
        $(e.target).val(value.slice(0, -1));
      }
    },
  },

  addressFormMethodInput: $('<input type="hidden" name="_method" value="put">'),
  populateAddressForm: function (addressId) {
    var $form = $('#AddressForm>form');

    // set form ID and action

    var action = '/account/addresses'
    var id = 'address_form_'

    if (addressId) {
      action += ('/' + addressId)
      id += addressId
    } else id += 'new'

    $form.attr('action', action)
    $form.attr('id', id)

    // populate form

    if (addressId) {

      $form.find('h2').html('Edit Address');
      $form.find('.cta').val('Edit Address');

      var address = this.customerAddresses[addressId]
      for (var key in address) {
        var selector = 'input[name="address[' + key + ']"], select[name="address[' + key + ']"]';
        $form.find(selector).val(address[key]);
      }

      setTimeout(function () {
        $('select[name="address[province]"]').val(address.province);
      }, 100);

      $form.append(this.addressFormMethodInput);

    } else {
      $form.find('h2').html('Add New Address');
      setTimeout(function () { $form.find('.cta').val('Add New Address') }, 100);

      $form.find('input').each(function () { $(this).val('') });
      $form.find('select').each(function () {
        $(this).val($(this).find('option').val());
      })

      $form.find(this.addressFormMethodInput).remove();
    }
  },

  populateDeleteAddressConfirm: function (addressId) {
    var $form = $('#DeleteAddressForm>form');
    $form.attr('action', $form.attr('action').replace(/\d*$/, addressId));
  },

  triggerModalClose: function () {
    $('.modal-overlay').addClass('hide');
    $('.modal').removeClass('active');
    $('body').removeClass('modal-active');
  },

  populateProvincesByCountry: function (self) {
    var $option = $(this);
    var provincesForCountry = $option.data('provinces').map(function (el) { return el[0] });
    self.provincesByCountry[this.value] = provincesForCountry;
  },

  // creates [HTMLElement] for a country as needed
  makeProvinceOptions: function (country) {
    var provinces = this.provincesByCountry[country];
    if (typeof provinces[0] !== 'string') return;

    var html = provinces.map(function (province) {
      return '<option value="' + province + '">' + province + '</option>';
    }).join('');

    this.provincesByCountry[country] = $.parseHTML(html);
  },

  // inserts appropriate options to province select
  insertCurrentProvinceOptions: function () {
    var currentCountry = $('select#AddressCountry').val()
    this.makeProvinceOptions(currentCountry);

    var $provinceSelect = $('select#AddressProvince');
    $provinceSelect.empty().append(this.provincesByCountry[currentCountry]);

    var firstOption = this.provincesByCountry[currentCountry][0];
    $provinceSelect.val(firstOption ? firstOption.value : '');
  },

  initProvinceSelects: function () {
    this.provincesByCountry = {};
    
    var self = this;
    $('select#AddressCountry option').map(function () {
      self.populateProvincesByCountry.call(this, self);
    })

    // set province options for current country
    this.insertCurrentProvinceOptions();
  },

});

export default ViewAccountAddresses;